import { render, staticRenderFns } from "./CarouselRow.vue?vue&type=template&id=53797e7b&scoped=true&"
import script from "./CarouselRow.vue?vue&type=script&lang=js&"
export * from "./CarouselRow.vue?vue&type=script&lang=js&"
import style0 from "./CarouselRow.vue?vue&type=style&index=0&id=53797e7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53797e7b",
  null
  
)

export default component.exports